/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  carrier: {},
  stateLoginUpdate: {},
  addStatus: '',
  editStatus: '',
  disabledStatus: false,

};

const getters = {
  carrier(state) {
    return state.carrier;
  },
  stateLoginUpdate(state) {
    return state.stateLoginUpdate;
  },
  getAddStatus(state) {
    return state.addStatus;
  },
  getEditStatus(state) {
    return state.editStatus;
  },
  getDisabledStatus(state) {
    return state.disabledStatus;
  },
};

const mutations = {
  updateCarrier(state, carrier) {
    state.carrier = carrier;
  },
  updateStateLoginUpdate(state, stateLoginUpdate) {
    state.stateLoginUpdate = stateLoginUpdate;
  },
  setAddStatus(state, status) {
    state.addStatus = status;
  },
  setEditStatus(state, status) {
    state.editStatus = status;
  },
  setDisabledStatus(state, status) {
    state.disabledStatus = status;
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js